import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Modal,
  Spin,
  Space,
  Button
} from "antd";
import { message } from "../../components/antdMessageBridge";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import CommonObj from "../../CommonObj";
import { Html5QrcodeScanType } from "html5-qrcode";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService from "../../components/commonregex/regexService";
import validationService from "../../components/commonvalidation/validationService";
import "./recycleManifest.css";

const ShipmentProcess = ({ title, onDataChange }) => {
  const [loading, setLoading] = useState(false);
    const [data, setData] = useState(onDataChange || []);
  const { accessToken, isAuthenticated } = useAuthToken();
  const [errors, setErrors] = useState({});
  const { roleUserId } = useAuth();
  const [regexLoaded, setRegexLoaded] = useState(false);
  const [loadId, setLoadId] = useState("");
  const [activeScanner, setActiveScanner] = useState(null);
  const [decodedResults, setDecodedResults] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);

  const [form, setForm] = useState({
    recycleBin: "",
    loadid:"",
    totalBookCount: "",
    weight: "",
    message: "",
  });
    const columns = [
        {
            title: "Recycle ID",
            dataIndex: "recycleBin",
            key: "recycleBin",
            width: '25%',
        },
        {
            title: "Total Book Count",
            dataIndex: "totalBookCount",
            key: "totalBookCount",
            width: '25%',
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
            width: '25%',
        },
        {
            title: "Action",
            key: "action",
            width: '25%',
            align: "center",
            render: (_, record) => (
                <Space size="middle">
                <Button
                  onClick={() => handleDelete(record.recycleBin)}
                  type="link"
                  size="small"
                >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15.3751 4.5H2.625"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            />
                            <path
                                d="M14.125 6.375L13.78 11.5493C13.6473 13.5405 13.5809 14.5361 12.9322 15.1431C12.2834 15.75 11.2856 15.75 9.29001 15.75H8.70999C6.71439 15.75 5.71659 15.75 5.06783 15.1431C4.41907 14.5361 4.3527 13.5405 4.21996 11.5493L3.875 6.375"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            />
                            <path
                                opacity="0.5"
                                d="M7.125 8.25L7.5 12"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            />
                            <path
                                opacity="0.5"
                                d="M10.875 8.25L10.5 12"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            />
                            <path
                                opacity="0.5"
                                d="M4.875 4.5C4.91691 4.5 4.93786 4.5 4.95686 4.49952C5.57444 4.48387 6.11927 4.09118 6.32941 3.51024C6.33588 3.49237 6.3425 3.47249 6.35576 3.43273L6.42857 3.21429C6.49073 3.02781 6.52181 2.93457 6.56304 2.8554C6.72751 2.53955 7.03181 2.32023 7.38346 2.26407C7.4716 2.25 7.56988 2.25 7.76645 2.25H10.2336C10.4301 2.25 10.5284 2.25 10.6165 2.26407C10.9682 2.32023 11.2725 2.53955 11.437 2.8554C11.4782 2.93457 11.5093 3.02781 11.5714 3.21429L11.6442 3.43273C11.6575 3.47244 11.6641 3.49238 11.6706 3.51024C11.8807 4.09118 12.4256 4.48387 13.0431 4.49952C13.0621 4.5 13.0831 4.5 13.125 4.5"
                                stroke="#002449"
                                stroke-width="1.2"
                            />
                        </svg>
                    </Button>
                </Space>
            ),
        },
    ];


    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
          await validationService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };
  
        if (accessToken) {
        loadRegexPatterns();
        }
    }, [accessToken]);
      
    useEffect(() => {
    //onShipment('shipment')
    //onDataChange(data);
    }, [data]);
  

  useEffect(() => {
    const uniqueResults = filterUniqueScans(decodedResults);
    if (uniqueResults?.length > 0 && activeScanner) {
      const latestResult = uniqueResults[uniqueResults?.length - 1];
      const scannedValue = latestResult?.decodedText;

      // Handle Recycle Bin ID field specifically - append instead of replace
      if (activeScanner === "Bin ID") {
        setForm((prev) => {
          const currentRecycleBin = prev.recycleBin ? prev.recycleBin.trim() : "";
          const newRecycleBin = currentRecycleBin ? `${currentRecycleBin}, ${scannedValue}` : scannedValue;
            return { ...prev, recycleBin: newRecycleBin.trim() };
        });
      } else if (activeScanner === "Load ID"){
          setForm((prev) => {
              return { ...prev, loadid: scannedValue.trim() };
          });
          setLoadId(scannedValue.trim());
          setErrors({});
      }
      else {
        setForm((prev) => {
          return { ...prev, [activeScanner.toLowerCase()]: scannedValue };
        });
      }

      setActiveScanner(null);
      setDecodedResults([]);
    }
  }, [decodedResults, activeScanner]);

    const getRowClassName = (record, index) => {
        return index % 2 === 0 ? "odd-row" : "even-row";
    };

    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results?.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results?.length; ++i) {
            if (results[i]?.decodedText !== results[i - 1]?.decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }

  const onNewScanResult = (decodedText, decodedResult) => {
    setDecodedResults((prev) => [...prev, decodedResult]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000); 
    const trimmedRecycleBin = form.recycleBin.trim();

    if (!trimmedRecycleBin) {
      message.error("Please enter or scan a Bin ID before proceeding.");
      return;
    }
    // Check if input contains comma-separated values
    const recycleBinArray = trimmedRecycleBin
      .split(',')
      .map(recycleBin => recycleBin.trim())
      .filter(recycleBin => recycleBin.length > 0);
    if (recycleBinArray.length === 0) {
      message.error("Please enter valid Recycle Bin ID(s).");
      return;
    }

    if (regexLoaded) {
      const invalidRecycleBin = recycleBinArray.find((recycleBin) => {
        const recycleBinError = validationService.validateRecycleBin(recycleBin);
        if (recycleBinError) {
          message.error(recycleBinError);
          return true;
        }
        return false;
      });

      if (invalidRecycleBin) {
        return;
      }
    }

    if (recycleBinArray.length > 1) {
      message.loading({ content: `Processing ${recycleBinArray.length} Recycle Bin ID(s)...`, key: 'processingRecycleBins' });

      let successCount = 0;
      let failCount = 0;

      const results = await Promise.allSettled(
        recycleBinArray.map(recycleBin => UserLogin(recycleBin.trim()))
      );

      results.forEach((result, index) => {
        if (result.status === 'fulfilled' && result.value === true) {
          successCount++;
        } else {
          failCount++;
        }
      });

      message.destroy('processingRecycleBins');

      if (successCount > 0) {
        message.success(`${successCount} Recycle Bin ID(s) added successfully!`);
      }
      if (failCount > 0) {
        message.warning(`${failCount} Recycle Bin ID(s) failed to add.`);
      }
      setForm((prev) => ({ ...prev, recycleBin: "" }));

    } else {
      await UserLogin(recycleBinArray[0]);
      setForm((prev) => ({ ...prev, recycleBin: "" }));
    }
  };

   
  async function UserLogin(recycleBin) {

    const isBookInTable = data.some((item) => item.recycleBin === recycleBin.trim());
    if (isBookInTable) {
      message.error(`Recycle Bin ID already exists in the grid.`);
      return false;
    }
    setLoading(true);

    try {
      let payLoad = {
        recycleBin: recycleBin.trim(),
        userId: roleUserId,
      };

      const response = await fetch(CommonObj.Endpoints.GetBinDetailsForShipment, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
          body: JSON.stringify(payLoad),
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const result = await response.json();
      console.log("shipmentResult", result);
      if (result && result[0]?.message) {
          message.error(`${result[0]?.message}`);
          return false;
      }
      else if (result && result?.length > 0) {
        const bookData = result[0];
        setData((prevData) => [...prevData, { ...bookData, key: bookData.recycleBin }]);
        return true;

      } else {
        message.error(`Failed to fetch data for recycleBin: ${recycleBin}`);
        return false;
      }
    } catch (error) {
      console.error(error.message);
      message.error(`Failed to fetch data for recycleBin ${recycleBin}: ${error.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  }

    const handleBinsLoadIdSubmit = async () => {
        const newErrors = {};
        let submissionData;
        console.log("submissionData", loadId, data.length);
        console.log("formloadid", form.loadid)
        if (loadId === "" || data.length === 0) {
            if (!loadId.trim()) {
                newErrors.loadId = "Load ID is required.";
                setErrors(newErrors)
            }
                
            message.error("Both Load ID and at least one Bin ID are required for shipment.");
            return;
        }
        else if (data.length > 0 && loadId !== "") {
            submissionData = {
                recycleBinIds: data.map((item) => item.recycleBin.trim()).join(","),
                loadId: loadId || "",
                createdBy: roleUserId,
            };
        }
        console.log("submissionData", submissionData);
        try {
            const baseUrl = CommonObj.Endpoints.RecycleShipmentSubmit;
            const response = await fetch(baseUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                },
                body: JSON.stringify(submissionData),
            });

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                message.success("Shipped Successfully.");
            } else if (result.message) {
                message.error(`${result.message}`);
                return;
            }
            else {
                message.error(`Failed to shipment the data.`);
                return;
            }

            setForm((prev) => ({ ...prev, recycleBin: "", loadid: "" }));
            setLoadId("");
            setData([]);
        } catch (error) {
            message.error(`Failed to shipment the data`);
        }
    };
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
    };

    if (loading) {
        return (
            <Spin size="large" style={{ margin: "20px auto" }} />
        );
    }

  return (
    <>
      <Modal
        title={`Scan ${activeScanner ? activeScanner : ""}`}
        open={!!activeScanner}
        onCancel={() => setActiveScanner(null)}
        footer={null}
        destroyOnClose
        width={1000}
        className="scan-model-container"
      >
        <div className="scan-modal">
          <Html5QrcodePlugin
            fps={30}
            qrbox={{ width: 1000, height: 400 }}
            aspectRatio={2.8}
            disableFlip={false}
            qrCodeSuccessCallback={onNewScanResult}
            supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
          />
        </div>
      </Modal>
     
      <div className="book-page-form">
        <div className="book-page-camera-button-container multiple scanner-unrestricted-field">
          <Input
            placeholder=""
            value={form.recycleBin}
            className={`${form.recycleBin ? "has-id" : ""}`}
            onChange={(e) => setForm({ ...form, recycleBin: e.target.value })}
            onPressEnter={handleSubmit}
            id="cutting-batch-bid-input-id"
            disabled={loading}          
          />
          {form.recycleBin.length === 0 && (
            <label htmlFor="cutting-batch-bid-input-id">
            Enter Recyle Bin ID / Scan “<strong>Recyle Bin ID</strong>”<span className="form-required">*</span>
            </label>
          )}
          <button
            type="button"
            className="book-page-camera-button"
            data-track="shipment-open-recycleBinId-scanner"
            onClick={() => { 
                setDecodedResults([]);
                setActiveScanner("Bin ID")
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="13"
                r="3"
                stroke="#1C274C"
                strokeWidth="1.5"
              />
              <path
                opacity="0.5"
                d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                stroke="#1C274C"
                strokeWidth="1.5"
              />
              <path
                d="M18 10H17.5"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                opacity="0.5"
                d="M14.5 3.5H9.5"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                fill="url(#paint0_linear_273_6917)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                fill="url(#paint1_linear_273_6917)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_273_6917"
                  x1="22.601"
                  y1="11.9503"
                  x2="1.98296"
                  y2="14.3301"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_273_6917"
                  x1="22.601"
                  y1="11.9503"
                  x2="1.98296"
                  y2="14.3301"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            type="button"
            className="book-page-camera-button-input-2"
            onClick={handleSubmit}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                fill="url(#paint0_linear_1900_8687)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1900_8687"
                  x1="20.6"
                  y1="9.94475"
                  x2="-0.0696504"
                  y2="12.0919"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>

      </div>
      <div className="table-container">
        <div className="rounded-table-wrapper">
          <Table
            columns={columns}
            dataSource={data}
            className="common-grid cutting-batch-processing comments-grid"
            pagination={false}
            rowKey={(record) => record.recycleBin}
            scroll={{ x: "max-content", y: "calc(100vh - 455px)" }}
            rowClassName={getRowClassName}
          />
        </div>
          </div>
          <div className="book-page-footer-container" style={{height:"80px"}}>
              <div className="book-page-action-container">
                  <div className="book-page-form-scan-rack-container">
                      <span className="form-required-rack" >*</span>
                      <input
                          className="book-page-form-scan-rack-button"
                          id="loadId"
                          name="loadId"
                          placeholder={'Enter Load ID / Scan "Load ID"'}
                          value={loadId}
                          onChange={(e) => {
                              setErrors({});
                              setLoadId(e.target.value.trim())
                          }}
                          required
                      ></input>
                      <button className="book-page-form-scan-rack-button-icon"
                          data-track="shipment-open-loadId-scanner"
                          onClick={() => {
                          setDecodedResults([]);
                          setActiveScanner("Load ID");
                            }}
                      >
                          <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                              <circle
                                  cx="12"
                                  cy="13"
                                  r="3"
                                  stroke="#1C274C"
                                  strokeWidth="1.5"
                              />
                              <path
                                  opacity="0.5"
                                  d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                  stroke="#1C274C"
                                  strokeWidth="1.5"
                              />
                              <path
                                  d="M18 10H17.5"
                                  stroke="#1C274C"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                              />
                              <path
                                  opacity="0.5"
                                  d="M14.5 3.5H9.5"
                                  stroke="#1C274C"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                              />
                          </svg>
                          <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                              <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                  fill="url(#paint0_linear_1086_13736)"
                              />
                              <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                  fill="url(#paint1_linear_1086_13736)"
                              />
                              <defs>
                                  <linearGradient
                                      id="paint0_linear_1086_13736"
                                      x1="22.601"
                                      y1="11.9503"
                                      x2="1.98296"
                                      y2="14.3301"
                                      gradientUnits="userSpaceOnUse"
                                  >
                                      <stop stopColor="#033D9B" />
                                      <stop offset="1" stopColor="#29ACD5" />
                                  </linearGradient>
                                  <linearGradient
                                      id="paint1_linear_1086_13736"
                                      x1="22.601"
                                      y1="11.9503"
                                      x2="1.98296"
                                      y2="14.3301"
                                      gradientUnits="userSpaceOnUse"
                                  >
                                      <stop stopColor="#033D9B" />
                                      <stop offset="1" stopColor="#29ACD5" />
                                  </linearGradient>
                              </defs>
                          </svg>
                      </button>
                      <span className="error-msg-rad">{errors.loadId}</span>
                  </div>
                  <div className="book-page-buttons-container justify-space-rack">
                      {/*<button className="reject-button" onClick={handleClear}>*/}
                      {/*    Clear*/}
                      {/*</button>*/}
                      <button
                          type="button"
                          className="accept-button "
                          disabled={isDisabled}
                          onClick={handleBinsLoadIdSubmit}
                      >
                          Submit
                      </button>
                  </div>
              </div>
          </div>
    </>
  );
};

export default ShipmentProcess;
